import React, { useContext, useState, useEffect } from 'react'

import ClaroPayContext from '../../context/ClaroPayContext'

import miPerfilIcon from '../../assets/img/miPerfilIcon.svg'
import editIcon from '../../assets/img/edit.svg'

const ClaroMiPerfil = () => {
  const claroPayContext = useContext(ClaroPayContext)

  const { miPerfilData } = claroPayContext

  const [state, setState] = useState({
    name: '',
    email: '',
    msisdn: '',
  })

  const [editName, setEditName] = useState(false)
  const [editEmail, setEditEmail] = useState(false)

  useEffect(() => {
    const name = miPerfilData.name
    const email = miPerfilData.email
    const msisdn = miPerfilData.msisdn?.slice(4)

    if (!name) {
      setEditName(true)
    }

    if (!email) {
      setEditEmail(true)
    }

    setState(prevState => ({
      ...prevState,
      name,
      email,
      msisdn,
    }))
  }, [miPerfilData])

  const handleChangeName = e => {
    const name = e.target.value
    setState(prevState => ({
      ...prevState,
      name,
    }))
  }

  const handleChangeEmail = e => {
    const email = e.target.value
    setState(prevState => ({
      ...prevState,
      email,
    }))
  }

  const handleEditName = () => {
    setEditName(!editName)
  }

  const handleEditEmail = () => {
    setEditEmail(!editEmail)
  }

  const { name, email, msisdn } = state

  return (
    <div className="claro__container__miPerfil">
      <div className="claro__container__miPerfil__perfil">
        <div className="claro__container__miPerfil__perfil__header">
          <div className="claro__container__miPerfil__perfil__header__image">
            <img src={miPerfilIcon} alt="miPerfil" />
          </div>
          <div className="claro__container__miPerfil__perfil__header__title">
            Mi Perfil
          </div>
        </div>

        <div className="claro__container__miPerfil__perfil__form">
          <div className="claro__container__miPerfil__perfil__form__label">
            Nombre
          </div>
          <div className="claro__container__miPerfil__perfil__form__input">
            <input
              id="name"
              type="text"
              value={name}
              onChange={handleChangeName}
              autoFocus
              readOnly={!editName}
            />
            {name && <img src={editIcon} alt="edit" onClick={handleEditName} />}
          </div>

          <div className="claro__container__miPerfil__perfil__form__label">
            Email
          </div>
          <div className="claro__container__miPerfil__perfil__form__input">
            <input
              id="email"
              type="email"
              value={email}
              onChange={handleChangeEmail}
              readOnly={!editEmail}
            />
            {email && (
              <img src={editIcon} alt="edit" onClick={handleEditEmail} />
            )}
          </div>

          <div className="claro__container__miPerfil__perfil__form__label">
            Teléfono
          </div>
          <div className="claro__container__miPerfil__perfil__form__input">
            <input id="msisdn" type="text" value={msisdn} readOnly />
          </div>
        </div>

        <div className="claro__container__miPerfil__perfil__options">
          <div className="claro__container__miPerfil__perfil__options__title">
            Formas de Pago
          </div>
          <div className="claro__container__miPerfil__perfil__options__button">
            Ver Tus Opciones de Pago
          </div>
        </div>

        <div className="claro__container__miPerfil__perfil__options">
          <div className="claro__container__miPerfil__perfil__options__title">
            Números Favoritos
          </div>
          <div className="claro__container__miPerfil__perfil__options__button">
            Ver Números
          </div>
        </div>
      </div>
    </div>
  )
}

export default ClaroMiPerfil
